import { render, staticRenderFns } from "./MaintenanceMenu.vue?vue&type=template&id=6f607edc"
import script from "./MaintenanceMenu.vue?vue&type=script&lang=js"
export * from "./MaintenanceMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports